var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"pink lighten-4","rounded":""}},[_c('p',{staticClass:"text-caption",staticStyle:{"padding":"8px"}},[_vm._v(" Tidak ada event tersedia saat ini ")])])}
var staticRenderFns = []

export { render, staticRenderFns }